/**
 * Plantilla por defecto del generador de links de invitación (dashboard).
 * Lo que definas aquí se usa como valores iniciales del formulario al generar un link.
 * La imagen que ve quien abre el link es exactamente la que se guardó al crear el link
 * (layout.background_image_url / layout.image_url desde la API de validación).
 *
 * Para usar tu propia imagen de fondo/logo:
 * - Opción 1: Definir env en Railway (menu): VITE_INVITATION_DEFAULT_BACKGROUND_IMAGE_URL y/o VITE_INVITATION_DEFAULT_IMAGE_URL
 * - Opción 2: Editar los valores por defecto abajo (ej. URL de Cloudflare Images).
 * No uses la imagen mobile del Bio (5722ef64...) salvo que sea la que quieras en la invitación.
 */
const fromEnv = (key: string): string => {
  const v = (import.meta.env as Record<string, unknown>)[key];
  return typeof v === "string" && v.trim() ? v.trim() : "";
};

export const INVITATION_DEFAULT_LAYOUT = {
  title: "",
  subtitle: "",
  message: "",
  theme: "" as "" | "light" | "dark" | "brand",
  cta_text: "",
  image_url: fromEnv("VITE_INVITATION_DEFAULT_IMAGE_URL"),
  background_image_url: fromEnv("VITE_INVITATION_DEFAULT_BACKGROUND_IMAGE_URL"),
  spots_remaining: "" as string | number,
  max_spots: "" as string | number,
};
